import { jsx as p, jsxs as J } from "react/jsx-runtime";
import { useState as R, useEffect as K } from "react";
import { CommentInput as u } from "../components/CommentInput/index.js";
import { CommentView as O } from "../components/CommentView/index.js";
import { SubmitAction as y, CommentAction as o } from "../types.js";
import { InputWrapper as L } from "./style.js";
function ii({
  edit: e,
  id: m,
  className: f,
  content: l,
  timestamp: A,
  author: s,
  authorImage: E,
  liked: S,
  count: w,
  badge: x,
  moreOptions: D,
  parentComment: Y,
  currentUser: i,
  areReactionsEnabled: j,
  reacted: V,
  reactions: _,
  isModerated: b,
  isPending: k,
  isDeleted: v,
  isEdited: B,
  isFocused: F,
  isNewComment: M,
  isAuthorVerified: N,
  profileURL: T,
  clickoutFunction: W,
  dispatch: g,
  goToProfile: n,
  commentsuggestions: d,
  disableReply: q,
  ...h
}) {
  const [r, I] = R(!1), [z, C] = R(!1);
  K(() => {
    C(!!e);
  }, [e]);
  const a = (c) => {
    const { type: t } = c;
    (t === y.EDIT || t === o.CANCEL_EDIT) && C(!1), t === o.REPLY && I((H) => !H), (t === o.SUBMIT || t === y.REPLY || t === o.CANCEL_REPLY) && I(!1), g(c);
  }, G = !!r;
  return z ? /* @__PURE__ */ p(L, { children: /* @__PURE__ */ p(
    u,
    {
      id: m,
      className: f,
      dispatch: a,
      author: s,
      authorImage: E,
      defaultValue: l,
      isEdit: !0,
      goToProfile: n,
      ...h,
      commentsuggestions: d
    }
  ) }) : /* @__PURE__ */ J("div", { children: [
    /* @__PURE__ */ p(
      O,
      {
        id: m,
        className: f,
        content: l,
        timestamp: A,
        author: s,
        authorImage: E,
        liked: S,
        count: w,
        badge: x,
        parentComment: Y,
        moreOptions: D,
        dispatch: a,
        clickoutFunction: W,
        isModerated: b,
        isPending: k,
        isDeleted: v,
        isEdited: B,
        isFocused: F,
        isNewComment: M,
        isAuthorVerified: N,
        areReactionsEnabled: j,
        reacted: V,
        reactions: _,
        goToProfile: n,
        profileURL: T,
        disableReply: q
      }
    ),
    G && /* @__PURE__ */ p(L, { className: "input-wrapper", children: /* @__PURE__ */ p(
      u,
      {
        id: m,
        className: f,
        dispatch: a,
        author: (i == null ? void 0 : i.nickname) || "",
        authorImage: i == null ? void 0 : i.profileImage,
        isReply: !0,
        ...h,
        commentsuggestions: d,
        goToProfile: n,
        isFocused: !0
      }
    ) })
  ] });
}
export {
  ii as Comment
};
